import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class SummaryRow extends Component {
    
    renderSummaryCells() {
        const { columns, source } = this.props;
        return _.map(
            columns,
            column => {
                if(column.sum) {
                    return <td key={column.dataIndex}>
                        {_.sumBy(source, item => parseFloat(item[column.dataIndex]))}
                    </td>
                };
                return <td key={column.dataIndex}></td>
            }
        )
    }
    
    render() { 
        return <tr className={'vt-table-summary'}>
            {this.renderSummaryCells()}
        </tr>
    }
};

export default SummaryRow;

// const mapStateToProps = (state) => {
//     const { source } = state.buhtable;
//     return {
//         source: source,
//     }
// };
 
// export default connect(mapStateToProps)(SummaryRow);



// WEBPACK FOOTER //
// ./src/components/VirtualTable/SummaryRow.jsx